import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { FieldOrderField, FlowOutputFieldOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type FieldsValidSortFields = FieldOrderField.NAME | FlowOutputFieldOrderField.NAME;

export const FieldsDefaultDirections: DefaultDirections<FieldsValidSortFields> = {
  NAME: OrderDirection.ASC,
};

export const FieldsDefaultSortField = FieldOrderField.NAME;

export function FieldsGridSortProvider(
  props: Pick<SortProviderProps<FieldsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<FieldsValidSortFields>
      validOrderFieldsWithDefaultDirections={FieldsDefaultDirections}
      defaultField={FieldsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
